import request from "@/axios/request";

//业务信息管理 - 处方汇总 - 处方记录
export function getPrescriptionRecord(data) {
  return request({
    url: '/business/diagnosisforweb/getPrescriptionRecord',
    method: 'post',
    data,
  })
}

//业务信息管理-处方汇总-处方记录-处方明细
export function getPrescriptionRecordDetail(data) {
  return request({
    url: '/business/diagnosisforweb/getPrescriptionRecordDetail',
    method: 'post',
    data,
  })
}
//业务信息管理-药店业务查询-订单打印
export function getDrugStorePrescriptionOrderList(data) {
  return request({
    url: '/business/diagnosisforweb/getDrugStorePrescriptionOrderList',
    method: 'post',
    data,
  })
}

//业务信息管理-药店业务查询-电子打印
export function getPrescriptionPdfNameList(data) {
  return request({
    url: '/business/diagnosisforweb/getPrescriptionPdfNameList',
    method: 'post',
    data,
  })
}
//处方记录查询分页
export function preRecordQuery(data) {
  return request({
    url: '/business/sysPrescription/preRecordQuery',
    method: 'post',
    data,
  })
}
//处方记录查询详情
export function getPrescriptionRecordDetailForPC(data) {
  return request({
    url: '/business/diagnosisforweb/getPrescriptionRecordDetailForPC',
    method: 'post',
    data,
  })
}
//公共web端处方详情
export function getPrescriptionOrderList(data) {
  return request({
    url: 'business/diagnosisforweb/getPrescriptionOrderList',
    method: 'post',
    data,
  })
}

// 业务信息管理/ 商城订单查询  (查询需要审核的商城订单)

export function getFastMallAuditRecordPage(data) {
  return request({
    url: '/order/payOrderFastMallAuditRecord/getFastMallAuditRecordPage',
    method: 'post',
    data,
  })
}

// 业务信息管理/ 商城订单查询 ( '查询需要审核的商城订单详情)
export function getFastMallAuditRecordDetail(data) {
  return request({
    url: '/order/payOrderFastMallAuditRecord/getFastMallAuditRecordDetail',
    method: 'post',
    data,
  })
}

//   业务信息管理/ 商城订单查询 '修改需要审核的订单的状态为审核中
export function editOrderAuditStatusUnderReview(data) {
  return request({
    url: '/order/payOrderFastMallAuditRecord/editOrderAuditStatusUnderReview',
    method: 'post',
    data,
  })
}
//   业务信息管理/ 商城订单查询 '驳回审核中的订单
export function turnDownOrder(data) {
  return request({
    url: '/order/payOrderFastMallAuditRecord/turnDownOrder',
    method: 'post',
    data,
  })
}

//   业务信息管理/ 商城订单查询 ''通过审核中的订单
export function passAuditOrder(data) {
  return request({
    url: '/order/payOrderFastMallAuditRecord/passAuditOrder',
    method: 'post',
    data,
  })
}

//   业务信息管理/ 商城订单查询 ''
export function rejectOrder(data) {
  return request({
    url: '/order/payOrderFastMallAuditRecord/rejectOrder',
    method: 'post',
    data,
  })
}

//   业务信息管理/ 商城退款审核 （查询商城退款审核列表）
export function getFastMallRefundAuditRecordPage(data) {
  return request({
    url: '/order/payOrderFastMallRefundAuditRecord/getFastMallRefundAuditRecordPage',
    method: 'post',
    data,
  })
}

//   业务信息管理/ 商城退款审核 （查询商城退款审核详情）
export function getFastMallRefundAuditRecordDetail(data) {
  return request({
    url: '/order/payOrderFastMallRefundAuditRecord/getFastMallRefundAuditRecordDetail',
    method: 'post',
    data,
  })
}

//   业务信息管理/ 商城退款审核 (驳回退款申请)
export function rejectionRefundRequest(data) {
  return request({
    url: '/order/payOrderFastMallRefundAuditRecord/rejectionRefundRequest',
    method: 'post',
    data,
  })
}

//   业务信息管理/ 商城退款审核 (通过退款订单)
export function passRefundOrder(data) {
  return request({
    url: 'order/payOrderFastMallRefundAuditRecord/passRefundOrder',
    method: 'post',
    data,
  })
}

//   业务信息管理/ 聊天记录查询
export function getHxMessagesList(data) {
  return request({
    url: 'chat/hxMessages/getHxMessagesList',
    method: 'post',
    data,
  })
}

// 获取处方卡片信息
export function getPrescriptionCardInfo(businessCode, hosId) {
  return request({
    url: 'business/proPrescriptionController/getPrescriptionCardInfo',
    data: {
      businessCode,
      hosId,
    },
    method: 'post',
  })
}

// 判断检验单预约状态
export function checkLisAppointStatus(pliId) {
  return request({
    url: 'basic/proLisInfoController/checkLisAppointStatus',
    data: { pliId },
    method: 'post',
  })
}

// 判断检查单预约状态
export function checkPacsAppointStatus(ppiId) {
  return request({
    url: 'basic/proPacsInfoController/checkPacsAppointStatus',
    data: { ppiId },
    method: 'post',
  })
}

// 查询聊天页面卡片-查询病历授权状态
export function getMedicalAuthorizeStatus(data) {
  return request({
    url: 'basic/proMedicalAuthorize/getMedicalAuthorizeStatus',
    data,
    method: 'post',
  })
}

// 查询量表是否已填写
export function getQuestionStatus(data) {
  return request({
    url: 'basic/proflocksend/getPatientFeedback',
    data,
    method: 'post',
  })
}

// 获取转诊记录状态
export function getReferralRecord(data) {
  return request({
    url: 'business/proReferralRecord/getReferralRecord',
    data,
    method: 'post',
  })
}

// 查询聊天页面卡片-自定义服务支付状态
export function findCustomServicePayStatus(data) {
  return request({
    url: 'business/proCustomBusiness/findCustomServicePayStatus',
    data,
    method: 'post',
  })
}

// 查询聊天页面卡片-自定义服务支付状态
export function getHxMessagesDetail(data) {
  return request({
    url: 'chat/hxMessages/getHxMessagesDetail',
    data,
    method: 'post',
  })
}

//web端-远程门诊查询所有医生   患者服务/远程会诊
export function remoteOutpatientConsultationForAllDoctors(data) {
  return request({
    url: 'basic/doctorWeb/remoteOutpatientConsultationForAllDoctors',
    data,
    method: 'post',
  })
}

//患者服务/远程会诊/'保存远程会诊信息
export function saveRemoteInfo(data) {
  return request({
    url: 'business/proRemoteConsultationInformation/saveRemoteInfo',
    data,
    method: 'post',
  })
}

//患者服务/远程会诊/'查询远程会诊详情
export function getRemoteDetail(data) {
  return request({
    url: 'business/proRemoteConsultationInformation/getRemoteDetail',
    data,
    method: 'post',
  })
}

// 查询会议中所有医生id
export function queryRemoteId(rciId) {
  return request({
    url: 'chat/remoteConsulation/queryRemoteId',
    data: {
      rciId,
    },
    method: 'post',
  })
}

// 远程会诊会议中邀请医生
export function inviteDoctorsInMetting(data) {
  return request({
    url: 'business/proRemoteConsultationInformation/inviteDoctorsInMetting',
    data,
    method: 'post',
  })
}

//患者服务/远程会诊/' '接受会诊邀请
export function acceptConsultationInvitation(data) {
  return request({
    url: 'business/proRemoteConsultationInformation/acceptConsultationInvitation',
    data,
    method: 'post',
  })
}

// 远程会诊详情
export function queryInfo(data) {
  return request({
    url: 'chat/remoteConsulation/queryInfo',
    data,
    method: 'post',
  })
}

// 发起会诊
export function sendConsult(data) {
  return request({
    url: 'chat/remoteConsulation/sendConsult',
    data,
    method: 'post',
  })
}
// 结束会议
export function closeConsult(data) {
  return request({
    url: 'chat/remoteConsulation/closeConsult',
    data,
    method: 'post',
  })
}
// 结束会议
export function editRemoteInfo(data) {
  return request({
    url: 'business/proRemoteConsultationInformation/editRemoteInfo',
    data,
    method: 'post',
  })
}
// 撤销会议

export function revokeConsultationInvitation(data) {
  return request({
    url: 'business/proRemoteConsultationInformation/revokeConsultationInvitation',
    data,
    method: 'post',
  })
}
//患者服务/远程会诊/' 驳回会诊邀请
export function rejectConsultationInvitation(data) {
  return request({
    url: 'business/proRemoteConsultationInformation/rejectConsultationInvitation',

    data,
    method: 'post',
  })
}

// 远程会诊详情
export function fillConclusionDto(data) {
  return request({
    url: 'chat/remoteConsulation/fillConclusionDto',
    data,
    method: 'post',
  })
}

// 业务信息管理/远程会诊信息管理（总中心/医院）/查询远程会诊列表
export function queryRemoteConsulationList(data) {
  return request({
    url: 'chat/remoteConsulation/queryRemoteConsulationList',
    data,
    method: 'post',
  })
}

// 业务信息管理/远程会诊信息管理（总中心/医院）/查询远程会诊列表
export function alongRemoteConsulationList(data) {
  return request({
    url: 'chat/remoteConsulation/alongRemoteConsulationList',
    data,
    method: 'post',
  })
}

// 业务信息管理/远程会诊信息管理 /远程会诊建议列表（发起方）
export function queryConsultationOpinionsInfo(data) {
  return request({
    url: '/chat/remoteConsulation/queryConsultationOpinionsInfo',
    data,
    method: 'post',
  })
}

// 业务信息管理/远程会诊信息管理 /查询远程会诊建议详情(参会方)
export function queryConsultationOpinionsDetail(data) {
  return request({
    url: '/chat/remoteConsulation/queryConsultationOpinionsDetail',
    data,
    method: 'post',
  })
}

// 业务信息管理/远程会诊信息管理 /参与会诊人员填写会诊建议
export function addParticipateConsultationOpinions(data) {
  return request({
    url: '/chat/remoteConsulation/addParticipateConsultationOpinions',
    data,
    method: 'post',
  })
}

// 业务信息管理/远程会诊信息管理 /参与会诊人员会诊建议详情
export function participateConsultationOpinionsDetail(data) {
  return request({
    url: '/chat/remoteConsulation/participateConsultationOpinionsDetail',
    data,
    method: 'post',
  })
}

// 添加苹果下载链接
export function insertSysIosUrls(data) {
  return request({
    url: '/chat/weblog/insertSysIosUrls',
    data,
    method: 'post',
  })
}

// // 查询苹果下载链接
// export function querySysIosUrls(data) {
//   return request({
//     url: '/chat/weblog/querySysIosUrls',
//     data,
//     method: 'get',
//   })
// }


// 医生到家问诊记录
export function getHomeTreatmentPageList(data) {
  return request({
    url: '/business/homeTreatment/homeTreatmentPageList',
    method: 'post',
    data,
  })
}

// 修改医生到家信息
export function updateHomeTreatment(data) {
  return request({
    url: '/business/homeTreatment/updateHomeTreatment',
    method: 'post',
    data,
  })
}

// 获取医生到家服务详情
export function getHomeTreatmentInfo(params) {
  return request({
    url: '/business/homeTreatment/getHomeTreatmentInfo',
    method: 'get',
    params,
  })
}

// 服务完成
export function completeHomeTreatmentService(params) {
  return request({
    url: '/business/homeTreatment/completeHomeTreatmentService',
    method: 'get',
    params,
  })
}

// 服务取消
export function cancelHomeTreatmentService(params) {
  return request({
    url: '/business/homeTreatment/cancelHomeTreatmentService',
    method: 'get',
    params,
  })
}

// 获取开通中医到家权限的医生
export function getHomeTreatmentDoctor(params) {
  return request({
    url: '/basic/doctor/homeTreatmentDoctor',
    method: 'get',
    params,
  })
}

// 获取用户检验报告
export function findPatientReport(params) {
  return request({
    url: '/business/paymentBusiness/findPatientReport',
    method: 'get',
    params,
  })
}

// 最新系统配置 05 19
export function getSysPlatformConfigByKeyList(arr = []) {
  return request({
    url: 'basic/sysPlatformConfig/getSysPlatformConfigByKeyList',
    method: 'post',
    params: {
      configKeyList: arr,
    },
  })
}


// 最高风险器官下拉选项
export function getRiskOrganOptionList(params) {
  return request({
    url: '/business/paymentBusiness/listTapRiskOrganOptions',
    method: 'get',
    params,
  })
}

//TAP-修改/删除最高风险器官或推荐检查项目
export function editTapRiskOrganOrCheckRecommend(data) {
  return request({
    url: '/business/paymentBusiness/operateTapReport',
    method: 'post',
    data,
  })
}

// TAP-实时计算推荐检查项目

export function resolveRecommendCheckItem(data) {
  return request({
    url: '/business/paymentBusiness/resolveRecommendCheckItem',
    method: 'post',
    data,
  })
}

